import type { GridColDef } from '@mui/x-data-grid';
import type { IngestedEventSample } from '@weft/types';
import type { ValueOf } from '@weft/utils';
import { dayjs } from '@weft/utils';
import { formatDate } from 'apps/app/src/utils/date';

export const EVENTS_COLUMNS_KEYS = Object.freeze({
  NAME: 'name',
  TIMESTAMP: 'timestamp',
  REF: 'ref',
  CUSTOMER_ALIAS: 'customerAlias',
  CUSTOMER_NAME: 'customerName',
  AFFECTED_METERS: 'affectedMeters',
});

export type EventsColumnsKey = ValueOf<typeof EVENTS_COLUMNS_KEYS>;

export const EVENTS_TABLE_COLUMNS: GridColDef<IngestedEventSample>[] = [
  {
    field: EVENTS_COLUMNS_KEYS.NAME,
    valueGetter: ({ row }) => row.name,
    headerName: 'Event Name',
    flex: 1,
  },
  {
    field: EVENTS_COLUMNS_KEYS.TIMESTAMP,
    valueGetter: ({ row }) => row.timestamp,
    headerName: 'Timestamp',
    flex: 1,
    renderCell: ({ value }) => (
      <span
        className="font-sans text-black"
      >
        {formatDate(dayjs(value))}
      </span>
    ),
  },
  {
    field: EVENTS_COLUMNS_KEYS.REF,
    valueGetter: ({ row }) => row.ref,
    headerName: 'Event Ref.',
    flex: 1,
  },
  {
    field: EVENTS_COLUMNS_KEYS.CUSTOMER_ALIAS,
    valueGetter: ({ row }) => row.customerAlias,
    headerName: 'Customer ID',
    flex: 1,
  },
  {
    field: EVENTS_COLUMNS_KEYS.CUSTOMER_NAME,
    valueGetter: ({ row }) => row.customerName,
    headerName: 'Customer Name',
    flex: 1,
  },
  {
    field: EVENTS_COLUMNS_KEYS.AFFECTED_METERS,
    valueGetter: ({ row }) => row.affectedMeters,
    headerName: 'Affected Meters',
    flex: 1,
  },
];